<template>
  <div class="login">
    <div class="logn_warp">
      <div class="newimg">
        <!-- <img src="@/assets/img/login3-logo.png" alt /> -->
      </div>
      <div class="domw">
        <!-- 下拉框 -->
        <el-dropdown @command="handleCommand" style="color: #fff; font-size: 18px">
          <span class="el-dropdown-link">
            {{ title_name }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh-cn">简体中文</el-dropdown-item>
            <el-dropdown-item command="en-us">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="fromd">
      <div class="logIns">
        <div class="lefCont">
          <div class="login-title">
            <!-- <div class="left_title"></div> -->
            <div class="userList">
              {{ dataObj.ousuwulianwangguanlipingtai }}
            </div>
            <!-- <div class="right_title"></div> -->
          </div>
          <el-form
            ref="formLabelAlign"
            :model="formLabelAlign"
            class="from"
            :rules="rules"
          >
            <el-form-item prop="username" class="listL">
              <el-input
                v-model="formLabelAlign.optname"
                :placeholder="dataObj.qingshuruzhanghao"
                clearable
              >
                <i slot="prefix" class="el-icon-user-solid" style="margin-top: 16px"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                :placeholder="dataObj.qingshurumima"
                v-model="formLabelAlign.optpassword"
                show-password
              >
                <i slot="prefix" class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item style="padding-top: 10px">
              <el-checkbox v-model="checked" style="color: #fff" @change="myoocs">{{
                dataObj.jizhumima
              }}</el-checkbox>
            </el-form-item>
            <el-form-item class="listnme" style="padding: 10px 0">
              <el-button type="primary" @click="regionClick('formLabelAlign')">{{
                dataObj.denglu
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <particles class="flexs" />
    <div class="box_ledtd">
      <!-- https://beian.miit.gov.cn/ -->
      <!-- https://beian.miit.gov.cn/?spm=a2cmq.17630005.0.0.7db379fe2JLYtO#/Integrated/recordQuery -->
      <a href="https://beian.miit.gov.cn/"> 备案号：{{ RecordNumber }} </a>
    </div>
  </div>
</template>
<script>
import { Longin, lang_fend } from "../../network/index";
import md5 from "js-md5";
import particles from "./components/particles";
import axios from "axios";
import { swart } from "@/network/baserURL";
export default {
  components: {
    particles,
  },
  data() {
    return {
      RecordNumber: "",
      title_name: "简体中文",
      checked: "",
      formLabelAlign: {
        optname: "",
        optpassword: "",
        lang_file: "zh-cn",
      },
      dataObj: {},
      lang_file: "zh-cn",
      rules: {
        // 账号
        name: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        //密码
        region: [{ required: true, message: "密码不能为空", trigger: "blur" }],
      },
    };
  },
  created() {
    // www.0311iot.com备案号为：冀ICP备16003206号-4，
    // www.ousuiot.com备案号为：16003206号-3
    const hostname = window.location.hostname;
    if (hostname == "www.0311iot.com") {
      this.RecordNumber = "冀ICP备16003206号-4";
    } else if (hostname == "www.ousuiot.com") {
      this.RecordNumber = "冀ICP备16003206号-3";
    } else {
      this.RecordNumber = "冀ICP备xxxxxxx号-x";
    }
    document.onkeypress = (e) => {
      // 登录
      let akeyEnd = document.all ? event.keyCode : e.which;
      if (akeyEnd === 13) {
        this.regionClick("formLabelAlign");
      }
    };
  },
  mounted() {
    var afterUrl = window.location.search;

    if (afterUrl.indexOf("?") != -1) {
      //判断是否有参数
      var str = afterUrl.substr(1); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
      var strs = str.split("="); //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
      this.formLabelAlign.optname = strs[1]; //直接弹出第一个参数 （如果有多个参数 还要进行循环的）
    }

    sessionStorage.setItem("lang_file", this.lang_file || "zh-cn"); //缓存中文还是英文
    this.getCookie();
    this.uend_end();
  },
  methods: {
    // 中英文切换
    uend_end() {
      let login_page = "login_page";
      axios({
        url: swart + "/Index/trans_page",
        params: {
          page: login_page,
          lang_file: this.lang_file,
        },
        method: "post",
      }).then((res) => {
        console.log(res.data.data);
        this.dataObj = res.data.data;
      });
    },
    //设置cookie
    myoocs(c_name, c_pwd, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      document.cookie =
        "optname=" + c_name + ";path=/;expires=" + exdate.toLocaleString();
      document.cookie =
        "optpassword=" + c_pwd + ";path=/;expires=" + exdate.toLocaleString();
    },
    //获取cookie
    getCookie() {
      // console.log(document.cookie.length);
      if (document.cookie.length > 23) {
        this.checked = true;
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "optname") {
            this.formLabelAlign.optname = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "optpassword") {
            this.formLabelAlign.optpassword = arr2[1];
          }
        }
      }
    },
    //删除cookie
    clearCookie() {
      // alert('111')
      this.checked = "";
      this.myoocs("", "", -1); //修改2值都为空，天数为负1天就好了
      this.formLabelAlign = {};
    },
    handleCommand(e) {
      this.lang_file = e;
      this.title_name = e == "en-us" ? "English" : "简体中文";
      this.uend_end(); //中英文切换
    },
    // 登陆验证
    regionClick(formName) {
      sessionStorage.setItem("lang_file", this.lang_file || "zh-cn"); //缓存中文还是英文
      this.$refs[formName].validate(async (valid) => {
        // console.log(valid);
        if (valid) {
          let optpassword = md5(this.formLabelAlign.optpassword);
          let clienttype = 1;
          const res = await Longin(
            this.formLabelAlign.optname,
            optpassword.toUpperCase(),
            clienttype
          );
          let objs = {
            optname: this.formLabelAlign.optname,
            optpassword: optpassword.toUpperCase(),
          };
          this.$store.commit("formLabelAlign", objs);
          console.log(res);

          let { code, msg } = res;
          // console.log(msg);
          if (code) {
            sessionStorage.setItem("username", res.data.optname); //缓存taoken userName
            sessionStorage.setItem("isagree", res.data.roletype1); //缓存主账号还是子账号
            if (this.checked) {
              this.myoocs(
                this.formLabelAlign.optname,
                this.formLabelAlign.optpassword,
                7
              );
            } else {
              // 清空缓存
              this.clearCookie();
            }

            const { appid, roletype } = res.data;
            // this.$message.success("登陆成功");
            sessionStorage.setItem("token", appid); //缓存taoken
            //  this.$store.commit('roletypeValue',roletype)
            sessionStorage.setItem("roletypeValue", roletype); //保存当前用户的状态 0 平台 1经销商 2 客户
            this.$router.push("/home");
          } else {
            this.clearCookie();
            this.$message.error(msg);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.domw {
  // display: flex;
  // justify-content: flex-end;
  padding: 10px 55px 0 0px;
}

.login {
  height: 100%;
  background: url("../../assets/img/lognL.jpg");
  position: relative;
}

.logIns {
  display: flex;
  // justify-content: space-around;
}

.fromd {
  width: 100%;
  height: 350px;
  // background-color: rgba(0, 0, 0, 0.102);
  // position: absolute;
  // top: 20%;
}

.newimgs {
  width: 60%;
  // margin: 0 auto;
  text-align: center;
}

.newimgs img {
  margin-top: 70px;
  margin-bottom: 10px;
}

.textList {
  color: #fff;
  font-size: 60px;
}

.lefCont {
  width: 400px;
  background-color: rgba(0, 0, 0, 0.2); //*背景
  height: 350px;
  margin: 0 auto;
}

.from {
  width: 322px;
  margin: 0 auto;
}

.net {
  text-align: center;
}

.left_title {
  width: 10%;
  border-bottom: 1px solid #fff;
}

.right_title {
  width: 10%;
  border-bottom: 1px solid #fff;
}

.login-title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  color: #fff;
  font-size: 18px;
}

.userList {
  padding: 0 20px;
  font-size: 25px;
  margin-top: 20px;
}

.logn_warp {
  display: flex;
  justify-content: space-between;
}

.newimg {
  margin: 42px 30px;
}

.box_ledtd {
  width: 100%;
  position: fixed;
  bottom: 50px;
  z-index: 2222;
  text-align: center;
}

.box_ledtd a {
  color: #fff;
  font-size: 14px;
}
</style>
